import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import QuoteSpotWrapper from "@components/layouts/quoteSpotWrapper";

export default function QuoteSpotHome(): ReactElement {
    return (
        <QuoteSpotWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#3fadc0" />
                </div>
                <FormSection iconsFillColor="#3fadc0" />
            </div>
        </QuoteSpotWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
